import React, { ChangeEvent, Dispatch } from 'react';
import classnames from 'classnames/bind';
import styles from './PriceRange.module.scss';

const CN = 'price-range';
const priceInputClassName = `${CN}__input`;
const priceDashClassName = `${CN}__dash`;
const priceCurrencyClassName = `${CN}__currency`;

const cx = classnames.bind(styles);

interface PriceRangeProps {
  min: number;
  max: number;
  onChangeCommitted: (value: [from: number, to: number]) => void;
  value: [from: number, to: number];
  setValue: Dispatch<[from: number, to: number]>;
}

export const PriceRange: React.FC<PriceRangeProps> = ({
  onChangeCommitted,
  min,
  max,
  value,
  setValue
}) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>): void => {
    if (event.target && event.target.name === 'from') {
      setValue([ +event.target.value, value[1] ]);
    } else if (event.target && event.target.name === 'to') {
      setValue([ value[0], +event.target.value ]);
    }
  };

  const handleBlur = (): void => {
    onChangeCommitted(value);
  };

  return (
    <div className={ cx(CN) }>
      <input
        className={ cx(priceInputClassName) }
        type='number'
        id='from'
        name='from'
        min={ min }
        max={ max }
        value={ value[0] }
        onChange={ handleChange }
        onBlur={ handleBlur }
      />
      <div className={ cx(priceDashClassName) }> - </div>
      <input
        className={ cx(priceInputClassName) }
        type='number'
        id='to'
        name='to'
        min={ min }
        max={ max }
        value={ value[1] }
        onChange={ handleChange }
        onBlur={ handleBlur }
      />
      <div className={ cx(priceCurrencyClassName) }> USD </div>
    </div>
  );
};
